
export const getCodeReference = (referenceId) => {
    return referenceId.substring(0, 3);
}